import { Expose } from 'class-transformer';

export class TaskTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
